//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            // key: value
            stateList:[],
        }
    },
    props: {
        list: {
            type: Array,
            default: []
        },
        type: { //列表类型 
            type: Number,
            default: 1     // 1 普通列表 2 折叠列表
        }
    },
    created () {
        const state = this.type == 1 ? true : false
        this.list.forEach((item , index) =>{
            this.stateList.push(state)
        })
    },
    methods: {
        show(index) {
            console.log(index)
            this.$set(this.stateList,index,!this.stateList[index])
            if(this.stateList[index]){
                this.$emit('showItemClick')
            }
        },
    },
}
